import script from "./AuthModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./AuthModal.vue?vue&type=script&lang=ts&setup=true"

import "./AuthModal.vue?vue&type=style&index=0&id=18f58d97&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18f58d97"]])

export default __exports__